import { render, staticRenderFns } from "./LogisticsImport.vue?vue&type=template&id=b33e843a&scoped=true"
import script from "./LogisticsImport.vue?vue&type=script&lang=js"
export * from "./LogisticsImport.vue?vue&type=script&lang=js"
import style0 from "./LogisticsImport.vue?vue&type=style&index=0&id=b33e843a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33e843a",
  null
  
)

export default component.exports